import { Component, input, output, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidButton } from '../rid-button/rid-button';
import { RidRatingStar } from '../rid-rating-star/rid-rating-star';

@Component({
  selector: 'rid-rating-modal',
  imports: [RidRatingStar, RidButton],
  templateUrl: './rid-rating-modal.html',
  host: {
    class: 'absolute',
    'animate.enter': 'anim-pop-in',
    'animate.leave': 'anim-pop-out',
  },
})
export class RidRatingModal {
  title = input<string>('Nauwkeurigheid');
  starsOnly = input<boolean>(false);

  protected readonly starLabels = ['enkele goed', 'gedeelte goed', 'merendeel goed', 'bijna alles goed', 'alles goed'];

  rating = signal<number | undefined>(undefined);

  canceled = output<void>();
  continued = output<void>();

  rate(rating: number) {
    this.rating.set(rating);

    if (this.starsOnly()) {
      delay(500).then(() => this.next());
    }
  }

  next() {
    this.continued.emit();
  }

  cancel() {
    this.canceled.emit();
  }
}
